import { render, staticRenderFns } from "./Cat3.vue?vue&type=template&id=0ad77b3a"
import script from "./Cat3.vue?vue&type=script&lang=js"
export * from "./Cat3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports